import React, {createContext, useEffect, useState} from "react";
import materialMovementService from "../../../../services/web/material-movement-service.js";
import {useQuery} from "@tanstack/react-query";

export const MaterialMovementsContext = createContext(undefined);

const MaterialMovementsProvider = ({children}) => {
    const [isLoading, setIsLoading] = useState(false)
    const [userSelected, setUserSelected] = useState("")

    const {data: cautions, isLoading: isLoadingCaution, refetch: refetchCautions} = useQuery({
        queryKey: ['cautions', userSelected],
        queryFn: () => materialMovementService.getByUser(userSelected.value),
        enabled: !!userSelected
    });

    useEffect(() => {
        setIsLoading(isLoadingCaution)
    }, [isLoadingCaution]);

    return (
        <MaterialMovementsContext.Provider value={{
            userSelected, setUserSelected, isLoading, setIsLoading, cautions, refetchCautions
        }}>
            {children}
        </MaterialMovementsContext.Provider>
    )
}
export default MaterialMovementsProvider;